import request from '@/utils/request'
const apiPath = '/sys/sysGoodsPlatformTag'

/**
 * 【商品平台标签】平台新品 / 平台爆款
 * REQ-2026-470053
 */
const sysGoodsPlatformTagApi = {
  /**
   * 平台标签选项（NEW/HOT），由后端下发，避免前端硬编码两份
   */
  options() {
    return request.get(`${apiPath}/options`)
  },
  /**
   * 自动新品天数配置，编辑页提示用
   */
  newTagDays() {
    return request.get(`${apiPath}/newTagDays`)
  },
  /**
   * 查询某个商品的平台标签
   */
  listByGoods(goodsId) {
    return request.get(`${apiPath}/listByGoods`, { params: { goodsId } })
  },
  /**
   * 批量设置平台标签
   */
  batchSet(data) {
    return request.post(`${apiPath}/batchSet`, data)
  },
  /**
   * 批量调整平台标签有效期
   */
  batchAdjust(data) {
    return request.post(`${apiPath}/batchAdjust`, data)
  },
  /**
   * 批量取消平台标签
   */
  batchCancel(data) {
    return request.post(`${apiPath}/batchCancel`, data)
  }
}
export default sysGoodsPlatformTagApi
